import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { KPI, Section } from "@/components/app/Primitives";
import TID from "@/lib/testIds";
import { FileText, Users, ShieldCheck, Wallet, Upload, Package } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/analytics/summary").then((r) => setS(r.data)).catch((err) => {
      console.debug("analytics load failed:", err?.message);
    });
  }, []);
  if (!s) return <div>Loading…</div>;

  const roleBlurb = {
    customer: "Submit orders, approve deliverables, and authorise payments — one vendor, one invoice.",
    procurement_desk: "Onboard invited influencers, issue back-to-back POs, release approved payments.",
    influencer: "Complete KYS, accept POs, deliver work, and get paid on schedule.",
    propay_admin: "Full L3 visibility across every FMCG customer, influencer, PO and payment.",
  }[user.role];

  return (
    <div className="space-y-6">
      <Section title={`Welcome back, ${user.name.split(" ")[0]}`} subtitle={roleBlurb} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI data-testid={TID.kpi("orders")} label="Total orders" value={s.total_orders} icon={FileText} />
        <KPI data-testid={TID.kpi("active")} label="Active orders" value={s.active_orders} tone="blue" icon={Package} />
        <KPI data-testid={TID.kpi("influencers")} label="Verified influencers" value={`${s.verified_influencers} / ${s.total_influencers}`} tone="green" icon={ShieldCheck} />
        <KPI data-testid={TID.kpi("reviews")} label="Deliverables to review" value={s.pending_deliverable_reviews} tone="amber" icon={Upload} />
        <KPI data-testid={TID.kpi("paid")} label="Total paid" value={s.total_paid.toLocaleString("en-IN", { style: "currency", currency: "INR" })} icon={Wallet} />
        <KPI data-testid={TID.kpi("pending")} label="Awaiting approval" value={s.pending_payments.toLocaleString("en-IN", { style: "currency", currency: "INR" })} tone="amber" />
        <KPI data-testid={TID.kpi("early_fees")} label="Early Payment Fees" value={s.early_payment_fees.toLocaleString("en-IN", { style: "currency", currency: "INR" })} tone="blue" />
      </div>
      <div className="bg-white rounded-xl border p-6">
        <h3 className="font-heading font-bold text-slate-900 mb-2">Process reminder</h3>
        <ol className="text-sm text-slate-600 space-y-1 list-decimal ml-5">
          <li>FMCG customer submits an Order (influencer contact + FMCG PO to ProPay + services).</li>
          <li>Procurement Desk invites the influencer and verifies KYS + bank via Cashfree Secure ID.</li>
          <li>Procurement Desk issues a back-to-back Purchase Order from <b>PROPAY GLOBAL PRIVATE LIMITED</b>.</li>
          <li>Influencer accepts the PO and uploads deliverables — AI classifies each item.</li>
          <li>FMCG primary contact approves deliverables and payment requests.</li>
          <li>Procurement Desk releases the payment; status reflects on all portals.</li>
        </ol>
      </div>
    </div>
  );
}
